// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const LaborRateMoalHeader = props =>
    <header className='labor-rate-modal-header'>
        <FormattedMessage id={`${props.actionToTake}_LABOR_RATE`}/>
        <div className='button-group'>
            <button onClick={props.onClose}>
                <FormattedMessage id='CANCEL'/>
            </button>
            <button
                className='button-primary'
                onClick={props.onConfirmation}
            >
                <FormattedMessage id='CONFIRM'/>
            </button>
        </div>
    </header>;

LaborRateMoalHeader.displayName = 'LaborRateMoalHeader';
LaborRateMoalHeader.propTypes = {
    actionToTake: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired
};

export default LaborRateMoalHeader;



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/components/modal/modal-header.js